import Vue from "vue";
import moment from "moment";
import ApiService from "../../../../../services/api";
import gridbase from "../../../../../components/gridComponentBase.js";
import { mapGetters } from "vuex";
import helpers from "../../../../../shared/fleetbox-helpers";
import { bus } from "../../../../../main";

export default {
	extends: gridbase,
	props: {
		filters: Array
	},
	data: function() {
		return {
			columns: [
				{
					field: "driver_name",
					title: "conducente",
					configId: "driver_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "number_plate",
					configId: "number_plate",
					title: "targa",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_code",
					configId: "vehicle_code",
					title: "codice",
					width: "100",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "brand_name",
					title: "marca",
					configId: "brand_name",
					width: "150",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "vehicle_name",
					title: "veicolo",
					configId: "vehicle_name",
					width: "200",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					sortable: false
				},
				{
					field: "division_name",
					title: "divisione",
					configId: "division_name",
					width: "90",
					headerCell: "myHeaderTemplate",
					format: "",
					filterable: false,
					permit: "hasDivisions",
					sortable: false
				},
				{
					field: "description",
					configId: "description",
					title: "evento",
					width: "350",
					headerCell: "myHeaderTemplate",
					format: "",

					filterable: false,
					sortable: false
				},
				{
					field: "latitude",
					configId: "latitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "longitude",
					configId: "longitude",
					title: "posizione",
					width: "120",
					headerCell: "myHeaderTemplate",
					format: "",
					cell: "positionCoordinates",
					filterable: false,
					sortable: false
				},
				{
					field: "event_date",
					configId: "event_date",
					title: "data",
					width: "200",
					headerCell: "myHeaderTemplate",
					cell: "myCellTemplate",
					format: "datetime",
					filterable: false,
					sortable: false
				}
			],

			config: [],
			columnsToShow: [],
			//items: [],
			hasDivisions: false
		};
	},

	created() {
		this.hasSelectedMode = true;
		this.query.pageSize = 25;
		this.take = 25;

		if (this.settings && this.settings.hasDivisions) this.hasDivisions = true;

		if (this.settings && this.settings.defaultPageSize && this.settings.defaultPageSize > 0) {
			this.query.pageSize = parseInt(this.settings.defaultPageSize);
			this.take = parseInt(this.settings.defaultPageSize);
		}
	},
	mounted() {
		this.getConfig();
	},
	watch: {
		// filters: {
		// 	handler: function() {
		// 		//this.query.page = 0;
		// 		this.getData();
		// 	},
		// 	deep: true
		// }
	},
	methods: {
		applyReportFilter() {
			this.skip = 0;
			this.query.page = 0;
			this.getData();
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position, tc);
			}
			return null;
		},
		getConfig: function() {
			var self = this;
			ApiService.getViewConfig("fleerun_report_driver_behavior")
				.then(res => {
					self.config = res;
					self.setConfigColumns();
				})
				.finally(res => {
					self.getData();
				});
		},
		setConfigColumns() {
			var self = this;
			if (self.config && self.config.length > 0) {
				var orderedConfigColumn = self._.orderBy(self.config, "order", "asc");

				orderedConfigColumn.forEach(column => {
					var defColumn = self.columns.find(function(f) {
						return f.configId === column.field;
					});

					if (defColumn && column.enabled && (!defColumn.permit || self[defColumn.permit])) {
						defColumn.title = column.label;

						self.columnsToShow.push(defColumn);
					}
				});

				if (self.columnsToShow.length > 0) {
					var columnsByPassConfig = self._.filter(self.columns, function(item) {
						return item.configByPass;
					});

					for (var i = 0; i < columnsByPassConfig.length; i++) {
						self.columnsToShow.push(columnsByPassConfig[i]);
					}
				}

				self.dataReady = true;
			}
		},
		sortChangeHandler: function(e) {
			this.sort = e.sort;
			this.getData();
		},
		pageChangeHandler: function(event) {
			this.skip = event.page.skip;
			this.take = event.page.take;

			if (this.skip === 0) {
				this.query.page = 0;
			}
			this.query.page = this.skip / this.take;

			this.getData();
		},
		downloadXlsx: function(type) {
			var self = this;
			var data = this.getRequestData();
			if (type == "csv") data["format"] = "csv";
			ApiService.exportXlsx("report/drivers/behaviors", data).then(res => {
				let blob = self.$options.filters.b64toBlob(res.data.fileContents);
				let link = document.createElement("a");
				var url = URL.createObjectURL(blob);
				link.setAttribute("href", url);
				link.setAttribute("download", res.data.fileDownloadName || `comportamento_conducenti.${type}`);
				link.style = "visibility:hidden";
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			});
		},
		getData: function() {
			var self = this;

			this.$emit("on-loading", true);

			var data = this.getRequestData();

			ApiService.getBehaviorsGridReport(data).then(res => {
				self.items = res.items.map(a => {
					return {
						id: a.id,
						driver_name: a.driver_name,
						number_plate: a.number_plate,
						vehicle_code: a.vehicle_code,
						brand_name: a.brand_name,
						event_date: a.event_date,
						vehicle_name: a.vehicle_name,
						division_name: a.division_name,
						description: a.description,
						latitude: a.latitude,
						longitude: a.longitude
					};
				});

				self.total = res.totalCount;

				self.$emit("on-loading", false);
			});
		},
		getRequestData() {
			var data = {};

			if (this.sort && this.sort.length > 0) {
				var sortParam = "";
				for (var i = 0; i < this.sort.length; i++) {
					if (i > 0) sortParam += ",";

					var fieldAndDir = this.sort[i];
					sortParam += `${fieldAndDir.field}|${fieldAndDir.dir}`;
				}

				data["sort"] = sortParam;
			}

			if (this.query.page) {
				data["page"] = this.query.page;
			}

			if (this.query.pageSize) {
				data["pageSize"] = this.query.pageSize;
			}

			if (this.filters && this.filters.length > 0) {
				this.filters.forEach(element => {
					switch (element.id) {
						case "timerange":
							data["dateRange.From"] = moment(element.value.startRange)
								.utc()
								.format();
							data["dateRange.To"] = moment(element.value.endRange)
								.utc()
								.format();
							break;
						case "drivers":
							if (element.value) {
								data["driver"] = element.value;
							}
							break;

						default:
							break;
					}
				});
			}

			return data;
		},
		isColumnFilterable(field) {
			if (this.columns) {
				var c = this.columns.find(function(f) {
					return f.field == field;
				});

				if (c && c.filterable) {
					return true;
				}
			}

			return false;
		}
	},
	computed: {
		...mapGetters(["settings"])
	}
};
